import Dashboard from './dashboard';
import Employe from './employe';
import EmployeObjectif from './employe-objectif';
import Contrat from './contrat';
import PropositionOffre from './proposition-offre';
import OffreEmploi from './offre-emploi';
import Candidature from './candidature';
import Formation from './formation';
import FormationSession from './formation-session';
import ProfilParticipant from './profil-participant';

import Checklist from './entretien/checklist';
import CampagneEntretien from './entretien/campagne-entretien';
import EntretienIndividuel from './entretien/entretien-individuel';
import EntretienIndividuelObjectif from './entretien/entretien-individuel-objectif';
import EntretienCollectif from './entretien/entretien-collectif';
import EntretienCollectifObjectif from './entretien/entretien-collectif-objectif';

export default [
  ...Dashboard,
  ...Employe,
  ...EmployeObjectif,
  ...Contrat,
  ...PropositionOffre,
  ...OffreEmploi,
  ...Candidature,
  ...Formation,
  ...FormationSession,
  ...ProfilParticipant,
  ...Checklist,
  ...CampagneEntretien,
  ...EntretienIndividuel,
  ...EntretienIndividuelObjectif,
  ...EntretienCollectif,
  ...EntretienCollectifObjectif,
];
